import { gatewayInstance } from "../server/gateway";

/**
 * @description 根据日期范围和用户列表获取日程信息列表
 */
export async function queryEmplReward(opts: { appId: string; teamId: string; userId: string }) {
  try {
    return gatewayInstance.request({
      api: "reward.queryEmplReward",
      method: "POST",
      body: opts
    });
  } catch (error) {
    console.log(error, "queryEmplReward");
  }
}

// 积分等级
export async function queryEmplMedalWall(body: any): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "reward.queryEmplMedalWall",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
